import React, { useEffect, useState, useRef } from 'react';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsServicesDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // Scroll to top when navigating to a new page
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-155">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <div className="flex justify-between h-16" data-id="element-157">
          <div className="flex items-center" data-id="element-158">
            <div className="flex-shrink-0 flex items-center" data-id="element-159">
              <Link to="/" onClick={scrollToTop} data-id="element-160">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4VmNYvHZzkjgPETo7E9Qew/Toddler-Time-Logo-nobackground-300x286.png" alt="Toddler Time Soft Play Rental & More Logo" className="h-[4.5rem] w-auto" data-id="element-161" />
              </Link>
              <span className="ml-2 text-primary-500 font-bold text-xl md:text-2xl hidden sm:block" data-id="element-162">
                Toddler Time Soft Play Rentals & More
              </span>
            </div>
          </div>
          {/* Desktop navigation */}
          <nav className="hidden md:ml-6 md:flex md:items-center md:space-x-4" data-id="element-163">
            <Link to="/" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500 transition" onClick={scrollToTop} data-id="element-164">
              Home
            </Link>
            <Link to="/about" className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500 transition" onClick={scrollToTop} data-id="element-165">
              About
            </Link>
            {/* Services dropdown */}
            <div className="relative" ref={dropdownRef} data-id="element-166">
              <button className="px-3 py-2 rounded-md text-sm font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500 transition flex items-center" onClick={() => setIsServicesDropdownOpen(!isServicesDropdownOpen)} data-id="element-167">
                Services
                <ChevronDownIcon className="ml-1 h-4 w-4" data-id="element-168" />
              </button>
              {isServicesDropdownOpen && <div className="absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10" data-id="element-169">
                  <div className="py-1" role="menu" aria-orientation="vertical" data-id="element-170">
                    <Link to="/softplay" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-500" role="menuitem" onClick={() => {
                  setIsServicesDropdownOpen(false);
                  scrollToTop();
                }} data-id="element-171">
                      Colorful Soft Play Packages
                    </Link>
                    <Link to="/luxurysoftplay" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-500" role="menuitem" onClick={() => {
                  setIsServicesDropdownOpen(false);
                  scrollToTop();
                }} data-id="element-172">
                      Luxury Soft Play Packages
                    </Link>
                    <Link to="/bouncehouse" className="block px-4 py-2 text-sm text-gray-700 hover:bg-primary-50 hover:text-primary-500" role="menuitem" onClick={() => {
                  setIsServicesDropdownOpen(false);
                  scrollToTop();
                }} data-id="element-173">
                      Bounce House Rentals
                    </Link>
                  </div>
                </div>}
            </div>
            <Link to="/faq" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => {
            setIsMenuOpen(false);
            scrollToTop();
          }} data-id="element-174">
              FAQ
            </Link>
            <Link to="/contact" className="ml-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500" onClick={scrollToTop} data-id="element-175">
              CONTACT US
            </Link>
          </nav>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden" data-id="element-176">
            <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-177">
              <span className="sr-only" data-id="element-178">Open main menu</span>
              {isMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-179" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-180" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu, show/hide based on menu state */}
      {isMenuOpen && <div className="md:hidden" data-id="element-181">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-182">
            <Link to="/" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-183">
              Home
            </Link>
            <Link to="/about" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-184">
              About
            </Link>
            {/* Mobile services dropdown */}
            <div data-id="element-185">
              <button className="flex justify-between w-full px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => setIsMobileServicesOpen(!isMobileServicesOpen)} data-id="element-186">
                <span data-id="element-187">Services</span>
                <ChevronDownIcon className="h-5 w-5" data-id="element-188" />
              </button>
              {isMobileServicesOpen && <div className="pl-6" data-id="element-189">
                  <Link to="/softplay" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => {
              setIsMenuOpen(false);
              scrollToTop();
            }} data-id="element-190">
                    Colorful Soft Play Packages
                  </Link>
                  <Link to="/luxurysoftplay" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => {
              setIsMenuOpen(false);
              scrollToTop();
            }} data-id="element-191">
                    Luxury Soft Play Packages
                  </Link>
                  <Link to="/bouncehouse" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => {
              setIsMenuOpen(false);
              scrollToTop();
            }} data-id="element-192">
                    Bounce House Rentals
                  </Link>
                </div>}
            </div>
            <a href="/#faq" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-primary-50 hover:text-primary-500" onClick={() => setIsMenuOpen(false)} data-id="element-193">
              FAQ
            </a>
            <Link to="/contact" className="block w-full text-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary-500 hover:bg-primary-600" onClick={() => {
          setIsMenuOpen(false);
          scrollToTop();
        }} data-id="element-194">
              CONTACT US
            </Link>
          </div>
        </div>}
    </header>;
};